<template>
<w-main-template>
  <w-apm-tree slot="sideContent" />
  <w-main-title slot="mainTitle" :title="selectedNode.label">
    <div slot="rightTool">
      <w-manage-tool-button-set v-show="isInstance" :obj="selectedNode.obj" />
      <w-datetime-range-button v-show="showDatetimeBtn" ref="dateBtn" />
    </div>
  </w-main-title>
  <component slot="mainContent" :is="currentView" />
</w-main-template>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import WMainTemplate from '@/components/template/MainTemplate';
import WMainTitle from '@/components/template/MainTitle';
import WManageToolButtonSet from '@/components/button/ManageToolButtonSet';
import WDatetimeRangeButton from '@/components/button/DatetimeRangeButton';
import WApmTree from './components/tree';
import WInstance from './instance';
import WApplication from './application';
import WKeyTransaction from './key-transaction';

export default {
  name: 'WApm',
  components: {
    WMainTemplate,
    WMainTitle,
    WManageToolButtonSet,
    WDatetimeRangeButton,
    WApmTree,
    WInstance,
    WApplication,
    WKeyTransaction,
  },
  data() {
    return {
      /**
       * 현재 화면 컴포넌트명
       * @type {String}
       */
      currentView: null,
    };
  },
  computed: {
    /**
     * 인스턴스일 경우에만 obj 버튼 show
     * @return {Boolean} [description]
     * @author jda
     */
    isInstance() {
      return this.$store.getters.isObj;
    },
    /**
     * 1. 도메인 > 요약
     * 2. 티어, 비즈니스 > 요약, 분석
     * 3. 인스턴스 > 분석, 이벤트
     * 4. 어플리케이션, 키트랜잭션 > 분석
     * 5. 인스턴스 티어 > 이벤트
     * 위 5가지 사항에서만 기간필터 컴포넌트 필요
     * @return {[type]} [description]
     * @author jda
     */
    showDatetimeBtn() {
      const type = this.selectedNode.type;
      const mainActiveTab = this.apmMainActiveTab;
      if (type === 'domain' && mainActiveTab === 'summary') {
        return true;
      } else if (type === 'group' && (mainActiveTab === 'summary' || mainActiveTab === 'analysis')) {
        return true;
      } else if (this.isInstance && mainActiveTab === 'event') {
        return true;
      } else if (mainActiveTab === 'analysis') {
        return true;
      } else if (type === 'group' && this.selectedNode.tierType === 'INSTANCE' && mainActiveTab === 'event') {
        return true;
      }
      return false;
    },
    ...mapGetters(['roles', 'activeTab', 'activeManagetypeIds', 'selectedNode']),
    ...mapState({
      apmTreeType: (state) => state.apm.treeType,
      apmMainActiveTab: (state) => state.apm.mainActiveTab,
    }),
  },
  watch: {
    /**
     * 선택된 노드가 변경될 때 조건에 맞는 화면 컴포넌트 설정
     */
    selectedNode: {
      immediate: true,
      handler(newNode, oldNode) {
        if (isEmpty(this.currentView) || newNode.treeKey !== oldNode.treeKey) {
          this.changeView();
        }
      },
    },
    apmTreeType() {
      this.changeView();
    },
  },
  mounted() {
    // this.$refs.dateBtn.reloadDate();
  },
  /**
   * 어플리케이션 메뉴 벗어나기 전에 탭 유지를 위한 state 정리
   * @return {[type]} [description]
   * @author jda
   */
  beforeDestroy() {
    this.$store.dispatch('setApmMainActiveTab', null);
    this.$store.dispatch('setApmSubActiveTab', null);
    this.$store.dispatch('setTxMatrixData', null);
  },
  methods: {
    /**
     * 선택된 트리 타입과 노드에 맞는 화면 컴포넌트 설정한다.
     * @return {[type]} [description]
     * @author jda
     */
    changeView() {
      const treeType = this.apmTreeType;
      if (treeType === 'instance') {
        this.currentView = WInstance.name;
      } else if (treeType === 'application') {
        this.currentView = WApplication.name;
      } else if (treeType === 'keyTrs') {
        this.currentView = WKeyTransaction.name;
      } else {
        this.currentView = null;
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/apm/index.vue